import { types as t, Instance } from 'mobx-state-tree';
import BitConfigType from '~/mst/common/bit_config_type';
import ThiamisDevice from '~/mst/models/device/thiamis';
import UserCalibrations from '../airthinx/user_calibrations';

const AethairProDeviceModel = t
  .compose(
    ThiamisDevice,
    t.model({
      pm_config: t.frozen(),
      pm_bin_counters: t.maybeNull(BitConfigType),
      user_calibration: t.maybeNull(UserCalibrations)
    })
  )
  .named('AethairPro');

export interface IAethairProDeviceModel extends Instance<typeof AethairProDeviceModel> {}

export default AethairProDeviceModel;
